<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
    <span class="scroll-top-inner" (click)="scrollToTop()">
        <fa-icon icon="arrow-circle-up"></fa-icon>
    </span>
</div>